import React from 'react';

const TARGET_ASK_VALUES = "target-ask-values";
const TARGET_SEND_VALUES = "target-send-values";

export default function useTopWindowData() {
    const [values, setValues] = React.useState(null);

    const listener = ({ data }) => {
        const { type, ..._values } = data || {};

        if (type === TARGET_SEND_VALUES) {
            setValues(_values);
        }
    };

    React.useEffect(() => {
        if (values === null) {
            window.addEventListener('message', listener);

            // notify parent window is ready
            window.parent.postMessage({
                id: window.name,
                type: TARGET_ASK_VALUES,
            }, '*');

            return () => window.removeEventListener('message', listener);
        }
    }, [values]);

    return values || {};
}
